import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { usePqrCallInfo } from './hook';
import { PqrCallInfoProps } from './props';

export const PqrCallInfo = (props: PqrCallInfoProps) => {
    const { formik } = usePqrCallInfo(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Información de la llamada
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <FieldText
                    label="Call ID"
                    name="callId"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.callId}
                    errors={formik.errors.callId}
                    value={formik.values.callId}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
